import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { State } from '../../../types/mx/reducers';
import * as ModalActions from '../../../../common/actions/ModalActions';
import LoseApplicationMotiveModalView from '../components/views/LoseApplicationMotiveModalView';
import {Catalog} from '../../../../common/types/common';
import {LOSE_APPLICATION_ACTION} from '../actions/FinishActions';

const mapStateToProps = (state: State, ownProps) => {
    const {loseApplicationReasons} = state.commonLoanApplication.catalogs;
    return {
        loseApplicationReasons,
        isForce: ownProps?.data?.isForce ?? false,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return {
        onClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onPressLose: (isForce:  boolean) => (reason: Catalog) => {
            dispatch(LOSE_APPLICATION_ACTION.action(reason, isForce));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onPressLose: dispatchProps.onPressLose(stateProps.isForce)
    };
};

const LoseApplicationMotiveModalContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(LoseApplicationMotiveModalView);

export default LoseApplicationMotiveModalContainer;
